import React, { forwardRef, useRef } from 'react';
import useForkRef from '@util/hook/useForkRef';
import { SelectField, MenuItem } from "@curves/ui-base";

const SelectWithOptions = forwardRef(({ label, defaultValue, options = [], fullWidth = false, displayEmpty = false, required, ...rest }, ref) => {
    const targetRef = useForkRef(useRef(null), ref);
    return (
        <SelectField key={defaultValue} ref={targetRef} label={label} defaultValue={defaultValue} fullWidth={fullWidth} required={required} {...rest}>
            {displayEmpty && (
                <MenuItem value="">
                    <em>請選擇</em>
                </MenuItem>
            )}
            {Array.isArray(options) &&
                options.map(({ text, value }) => (
                    <MenuItem key={value} value={value}>
                        {text}
                    </MenuItem>
                ))}
        </SelectField>
    );
});

export default SelectWithOptions;
